import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateAssignedStatuses } from '@api/configurationTemplates';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_ASSIGNED_STATUSES } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesAssignedStatuses {
	assignedStatuses: TSelectOption<string>[];
	isLoadingAssignedStatuses: boolean;
}

const useQueryConfigurationTemplatesAssignedStatuses = (): IUseQueryConfigurationTemplatesAssignedStatuses => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_ASSIGNED_STATUSES],
		queryFn: getConfigurationTemplateAssignedStatuses,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		assignedStatuses: data || [],
		isLoadingAssignedStatuses: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesAssignedStatuses;
